import { gql } from '@apollo/client';

export default gql`
  mutation deleteBookingItems($bookingReference: String!, $itemRefs: [Int]!) {
    deleteBookingItems(bookingReference: $bookingReference, itemRefs: $itemRefs) {
      reference
    }
  }
`;
